import makeHTTPRequest from 'GrooveHTTPClient/makeHTTPRequest';

export const show = () => makeHTTPRequest({ path: '/api/v2/product_usage' });
